import { render, staticRenderFns } from "./CreateArticleCalculation.vue?vue&type=template&id=4cda8bc4"
import script from "./CreateArticleCalculation.vue?vue&type=script&lang=js"
export * from "./CreateArticleCalculation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports